import { render, staticRenderFns } from "./add-dialog.vue?vue&type=template&id=add841d0&scoped=true&"
import script from "./add-dialog.vue?vue&type=script&lang=js&"
export * from "./add-dialog.vue?vue&type=script&lang=js&"
import style0 from "./add-dialog.vue?vue&type=style&index=0&id=add841d0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add841d0",
  null
  
)

export default component.exports